import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Info = () => {

    useEffect(()=> {
        document.getElementById("info").style.backgroundColor = "#FF8303"
    }, [])
    return (
        <div>
            <Navbar></Navbar>

            <section class="gradient-main h-600 relative flex items-center overflow-hidden">
                <img alt="" class="absolute h-full" src={require("../assets/background.png")}></img>
                <div class="ml-14 mb-14 info-text-container">
                    <h1 class="text font-title text-white text-4xl absolute -translate-y-36 ">Toote info</h1>
                    <p class="text2 font-sec text-white text-2xl absolute w-1/3 -translate-y-24">Sunsett Sipper on värskendav ja energiat andev jook, mis on loodud selleks, et toetada sinu aktiivset eluviisi. Meie unikaalne retsept kombineerib looduslikke koostisosi.</p>
                </div>
                <div class="absolute flex items-center h-full right-24 mb-24">
                    <img class="bottle image-" src={require("../assets/info-img.png")} alt="" />
                </div>
                <div class="flex absolute -bottom-4">
                    <img alt="" src={require("../assets/cloud.png")}></img>
                    <img alt="" src={require("../assets/cloud.png")}></img>
                </div>
            </section>

            <section>
                <div class="flex justify-center">
                    <img src={require("../assets/Star-pointed.png")} alt=""></img>
                </div>
                <h1 class="text-center primary font-title text-2xl">Peamised omadused</h1>
                <div class="flex pl-16 pr-16 mt-16 noflex">
                    <div class="bg-color-2 rounded-l-md p-6">
                        <img src={require("../assets/icons8-orange-96.png")} alt=""></img>
                        <h1 class="text-white font-title text-2xl">Lojaalsed koostisosad</h1>
                        <p class="text-white font-sec text-xl">100% looduslikud koostisosad, sealhulgas guaraana, matcha ja supertoidud.</p>
                    </div>
                    <div class="bg-color-1 p-6">
                        <img src={require("../assets/icons8-vitamins-64.png")} alt=""></img>
                        <h1 class="text-white font-title text-2xl">Vitamiinid ja mineraalid</h1>
                        <p class="text-white font-sec text-xl">Rikastatud oluliste vitamiinidega, mis toetavad immuunsust ja üldist heaolu.</p>
                    </div>
                    <div class="bg-color-2 rounded-r-md p-6">
                        <img src={require("../assets/icons8-thunderbolt-100.png")} alt=""></img>
                        <h1 class="text-white font-title text-2xl">Energialaks</h1>
                        <p class="text-white font-sec text-xl">Tasakaalustatud kofeiinisisaldus, mis aitab sul end päeva jooksul tunda värskena ja energilisena.</p>
                    </div>
                </div>
            </section>
            
            <Footer isBottom={false}></Footer>
        </div>
    )
}

export default Info;